import { DateHelper, StringHelper } from "../../../../../helper";

export const useMTPDetailColumns = () => {
  const columns = [
    {
      title: "",
      dataIndex: "eTitle",
      key: "eTitle",
      render: (text: string) =>
        StringHelper.verticalBarSplit<string[]>(text)[1] || text,
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 13 : 1,
      }),
    },
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
    },
    {
      title: "Môn học",
      dataIndex: "eSubject",
      key: "eSubject",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
    },
    {
      title: "Loại hình đào tạo",
      dataIndex: "eTrainingType",
      key: "eTrainingType",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
    },
    {
      title: "Học viên",
      dataIndex: "eTrainees",
      key: "eTrainees",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
    },
    {
      title: "Số lượng",
      dataIndex: "eTrainingCount",
      key: "eTrainingCount",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
    },
    {
      title: "Đối tượng",
      dataIndex: "eTraineeObject",
      key: "eTraineeObject",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
    },
    {
      title: "Thời lượng",
      dataIndex: "eLessonTypes",
      key: "eLessonTypes",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
    },
    {
      title: "Từ ngày",
      dataIndex: "eDateTime",
      key: "eDateTime",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
      render: (_: string, record: any) => {
        return DateHelper.formatDateToString(record?.eDateTime?.[0]);
      },
    },
    {
      title: "Đến ngày",
      dataIndex: "eDateTime",
      key: "eDateTime",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
      render: (_: string, record: any) => {
        return DateHelper.formatDateToString(record?.eDateTime?.[1]);
      },
    },
    {
      title: "Địa điểm",
      dataIndex: "eCoursePlaces",
      key: "eCoursePlaces",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
    },
    {
      title: "Giáo viên/Đối tác",
      dataIndex: "eCourseTrainee",
      key: "eCourseTrainee",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
    },
    {
      title: "Ghi chú",
      dataIndex: "eNotes",
      key: "eNotes",
      onCell: (record: any) => ({
        colSpan: record?.eTitle ? 0 : 1,
      }),
    },
  ];

  return { columns };
};
